import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {SearchInputType} from "@components/custom/Search";
import Search from "@components/custom/Search";

interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SearchCitiesComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "query",
    label: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
    type: SearchInputType.TEXT,
    size : 12
  }, {
    name: "province_id",
    label: <FormattedMessage id="app.province" defaultMessage={`Province`}/>,
    type: SearchInputType.PROVINCE,
    size : 12
  }];
  
  return <Search inputs={inputs} search={search}/>
  
};

export default SearchCitiesComponent;